import React,{useEffect} from 'react'
// import usePokemonFetch from '../hooks/usePokemonFetch'
import {useParams, useHistory} from 'react-router-dom'
import { useSelector, useDispatch} from 'react-redux'
import {getPokemonDetail} from '../store/actions/pokemonAction'

export default function Detail() {
    const { pokemonId } = useParams()
    // const {pokemons:detail} = usePokemonFetch(`https://pokeapi.co/api/v2/pokemon/${pokemonId}`)
    const detail = useSelector((state)=> state.pokemonReducer.pokemon)
    const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(getPokemonDetail(pokemonId))
    },[dispatch,pokemonId])

    const history = useHistory()

    function closeDetail(){
        history.goBack()
    }

    return (
        <>
        <h2 style={{textAlign: "center"}} data-testid="detail-title">Pokemon Detail</h2>
        {!detail && <img style={styles.loading} src="https://thumbs.gfycat.com/FairSinfulCottontail-max-1mb.gif" alt="loading" />}
        {detail && <div className="card mb-3 ml-3 mr-3 mt-3" style={{maxWidth: "540 px"}}>
                <div className="row">
                    <div className="col-sm">
                        <img src={`https://pokeres.bastionbot.org/images/pokemon/${detail.id}.png`} className="card-img ml-2" alt="pokemon" />
                    </div>
                    <div className="col-sm">
                    <div className="card-body">
                        <h3 className="card-title">{detail.name}</h3>
                        <h5 className="card-text">height: {detail.height/10} meter(s)</h5>
                        <h5 className="card-text">weight: {detail.weight/10} kg(s)</h5>
                        <h5 className="card-test mb-0">type: </h5>
                        {detail.types.map((tipe,idx)=>{
                            return (
                                <div key={idx}>
                                    <li>{tipe.type.name}</li>
                                </div>
                            )
                        })}
                        <button  onClick={closeDetail} className="btn btn-danger mt-4">Close</button>
                    </div>
                    </div>
                </div>
            </div>}
        </>
    )
}

const styles = {
    loading: {
        display: "block",
        margin: "0 auto"
    }
}